export class VariantStringModel {
    ManualConfigurationId: number;
    ManualConfigurationUuid: string;
    ManualConfigCollectionId: number;
    ManualConfigurationGroupId: number;
    VariantString: string;
    VariantValues: string;
}